<template>
  <div>
    <div class="form-group boolean program_consent">
      <div class="checkbox">
        <label
          class="program-consent-label"
          for="program-consent-checkbox"
        >
          <input
            id="program-consent-checkbox"
            v-model="acceptedProgramConsent"
            :class="`program-consent-checkbox ${ rwcOrSportsnet ? 'rwc-or-sportsnet' : '' }`"
            type="checkbox"
            name="program_consent_checkbox"
            @change="updateProgramConsent"
          >
          <span
            class="custom-checkbox"
          />
          <div class="program-consent-text-wrapper">
            <!-- eslint-disable vue/no-v-html -->
            <span
              class="program-consent-text"
              v-html="programConsentVerbiage"
            />
            <!-- eslint-enable -->
          </div>
        </label>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProgramConsentCheckbox',
  emits: ['update-program-consent'],
  data() {
    return {
      acceptedProgramConsent: false
    }
  },
  computed: {
    programConsentVerbiage() {
      if(this.rwcOrSportsnet){
        return this.$t('creditCardForm.rwcProgramConsent')
      } else if(window.sportsnet_based){
        return this.$t('creditCardForm.sportsnetBasedProgramConsent')
      } else {
        return this.$t('creditCardForm.programConsent')
      }
    },

    rwcOrSportsnet() {
      return ['rwc', 'sportsnet'].includes(window.name)
    }
  },
  methods: {
    updateProgramConsent() {
      this.$emit('update-program-consent', this.acceptedProgramConsent)
    }
  },
}

</script>